import { CommunityCardContactMode } from "@sp-crm/core";
import { SelectPro } from "components/ui/select-pro";
import React from "react";

interface CommunityCardContactModeSelectProps {
    value: CommunityCardContactMode;
    onChange: (value: CommunityCardContactMode) => void;
    disabled?: boolean;
}

const labelForCommunityCardContactMode = (key: CommunityCardContactMode) => {
    switch (key) {
        case CommunityCardContactMode.All:
            return "All Contacts";
        case CommunityCardContactMode.Primary:
            return "Primary Contacts Only";
        case CommunityCardContactMode.None:
            return "No Contacts";
        default: {
            const exhaustiveCheck: never = key;
            console.warn(`Unhandled community card contact mode: ${exhaustiveCheck}`);
            return "";
        }
    }
};

export const CommunityCardContactModeSelect: React.FC<
    CommunityCardContactModeSelectProps
> = ({ value, onChange, disabled }) => {
    return (
        <SelectPro
            label="Contacts to show on community card"
            disabled={disabled}
            value={value}
            onChange={e => onChange(e.target.value as CommunityCardContactMode)}
            options={Object.keys(CommunityCardContactMode).map(key => ({
                value: key,
                text: labelForCommunityCardContactMode(key as CommunityCardContactMode),
            }))}
        />
    );
};
